import type { CollapseProps as CoreUICollapseProps } from '@eleo-rh/core-ui'
import { Collapse as CoreUICollapse } from '@eleo-rh/core-ui'

export type CollapseProps = CoreUICollapseProps

function Collapse(props: CollapseProps) {
  return <CoreUICollapse expandIconPlacement="start" styles={{ root: { borderRadius: 4 } }} {...props} />
}

export default Collapse
